// The client can't query markets at build time, so route constraints
// hardcode the slugs Rails serves. spec/lib/client_market_slugs_spec.rb
// fails CI when either list drifts from db/seeds.rb.
export const MARKET_SLUGS = [
  'vic',
  'nsw',
  'nz',
  'washington',
  'oregon',
  'california',
] as const

// Countries with their own landing page. A country whose code doubles as a
// market slug (NZ) is served by the market route instead.
export const COUNTRY_CODES = ['au', 'us'] as const

export const marketPathConstraints = `(${MARKET_SLUGS.join('|')})`

export const countryPathConstraints = `(${COUNTRY_CODES.join('|')})`
